<template>
    <div :class="positionClass">
        <form action="">
            <div class="form_control">
                <label>Subtitel</label>
                <input type="text" placeholder="Artikel Titel" v-model="section.titel" @change="updateArtikel">
            </div>
            <div class="form_control">
                <label>Artikel</label>
                <textarea cols="10" rows="15"  placeholder="Intro van het artikel" v-model="section.artikel" @change="updateArtikel"></textarea>
            </div>
            <div class="file_input">
                <div class="form_control ">
                    <label for="foto">Afbeelding</label>
                    <input type="file" id="foto" name="foto" @change="addImage">
                </div>
            </div>
            <div class="form_control">
                <p v-if="section.id == 'new'" class="button" @click="$emit('section_delete_temp', temp_id)">Verwijder sectie</p>
                <p v-else class="button" @click="$emit('section_delete', section.id)">Verwijder sectie</p>
            </div>
        </form>
        <div class="edit__box__input__hoofdafbeelding__img">
            <img v-if="section.img == ''" src="assets/img_placeholder.png" alt="">
            <img v-else :src="section.img"  alt="">
        </div>
    </div>
</template>
<script>
export default {
    props:['position', "image", "artikel", "titel", "s_id", "temp_id" ],
    data(){
        return{
            positionClass: "",
            section: {
                temp_id: this.$props.temp_id,
                id: this.$props.s_id,
                position: this.$props.position,
                img: this.$props.image,
                artikel: this.$props.artikel,
                titel: this.$props.titel,
                foto: "",
                upload: false
            }
        }
    },
    created(){
        if(this.$props.position === 'left'){
            this.positionClass = "edit__box__project__wrapper edit__box__project__wrapper__left"
        } else if(this.$props.position === 'right'){
            this.positionClass = "edit__box__project__wrapper"
        }
    },
    methods:{
        updateArtikel(){
            this.$emit('artikel-update', this.section)
        },
        addImage(event){
            this.section.upload = true;
            this.section.foto = event.target.files;
            this.section.img = URL.createObjectURL(event.target.files[0])
            this.updateArtikel();
        },
    }
}
</script>